import React, { useEffect, useState } from 'react';
// import { Loading } from '@components';
import NotificationList from './NotificationList';
import { useNotification } from './NotificationProvider';
import { Switch, Spin } from 'antd';
import { useFetch } from '../hooks/useFetch';
// import { getCommentStatus, updateCommentStatus } from '@service/apis';
// import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const NotificationPanel = () => {
  const {
    isReadCollapsed,
    setIsReadCollapsed,
    loading,
    loadMoreLoading,
    selfEmail: userId,
    getCommentStatus,
    updateCommentStatus,
    projectId,
  } = useNotification();

  const {
    response,
    error,
    isLoading: emailNotificationIsLoading,
  } = useFetch(getCommentStatus, projectId, userId);

  const [emailNotificationFlag, setEmailNotificationFlag] = useState();
  const onChange = async (checked) => {
    setEmailNotificationFlag(checked);
    await updateCommentStatus(projectId, userId, checked);
  };

  useEffect(() => {
    if (!emailNotificationIsLoading) {
      // loading is done
      setEmailNotificationFlag(response?.commentStatus?.emailNotificationFlag);
    }
  }, [emailNotificationIsLoading]);

  return (
    <div className="notification-center-console">
      <div className="console-header">
        <div className="console-title">Notifications</div>
        <div className="console-switch">
          {emailNotificationIsLoading ? (
            <Spin
              indicator={antIcon}
              spinning={true}
              // className="comment-loading-wrapper"
            />
          ) : (
            <Switch checked={emailNotificationFlag} onChange={onChange} />
          )}
          <span>Email Notifications</span>
        </div>
      </div>

      <NotificationList />

      <div
        className="notification-view-readbtn"
        style={{ display: isReadCollapsed ? 'flex' : 'none' }}
      >
        <span onClick={() => setIsReadCollapsed(!isReadCollapsed)}>
          View read notifications
        </span>
      </div>

      {/* <Loading
        isLoading={loading || loadMoreLoading}
        className="notification-loading"
      /> */}
      <Spin
        indicator={antIcon}
        spinning={loading || loadMoreLoading}
        className="comment-loading-wrapper"
      />
    </div>
  );
};

export default NotificationPanel;
